const FIELDS = ['address', 'address2', 'city', 'state', 'zipcode', 'latitude', 'longitude'];

export function formFromRecord(record) {
    const form = {};
    FIELDS.forEach(field => {
        const value = record ? record[field] : null;
        form[field] = value === null || value === undefined ? '' : String(value);
    });
    return form;
}

export function validate(form) {
    if(!form.address.trim()) {
        return 'Enter a street address.';
    }

    const latitude = form.latitude.trim();
    const longitude = form.longitude.trim();
    if(!latitude !== !longitude) {
        return 'Enter both latitude and longitude, or leave both blank.';
    }
    if(latitude && !(Math.abs(Number(latitude)) <= 90 && Math.abs(Number(longitude)) <= 180)) {
        return 'Latitude must be between -90 and 90, and longitude between -180 and 180.';
    }

    return null;
}

export function locationSummary(record) {
    if(!record || record.latitude === null) {
        return 'Not on the inspection map: no location was found for this address. Enter latitude and longitude to place it.';
    }

    const source = record.location_source === 'census' ? 'found by the Census geocoder' : 'entered by hand';
    return `On the inspection map, ${source}.`;
}
